import React from 'react';
import type { FC } from 'react';
import { Text } from '../Text.js';

interface HighlighterProps {
  text: string;
  pattern?: RegExp;
}

export const Highlighter: FC<HighlighterProps> = ({ pattern, text }) => {
  if (!pattern) {
    return text;
  }

  const matches = text.matchAll(pattern);
  const hightlightMap = new Array(text.length).fill(0);

  for (const match of matches) {
    const start = match.index;
    const end = match.index + match[0].length;

    for (let i = start; i < end; i++) {
      hightlightMap[i] = +1;
    }
  }

  return hightlightMap.map((flag, index) => (
    <Text key={index} skin={flag ? 'secondary' : 'standard'}>
      {text[index]}
    </Text>
  ));
};
